<script setup>
import { provide, inject, useId } from "vue";
import { cn } from "@/shared/lib/utils";
import { FORM_ITEM_INJECTION_KEY } from "./injectionKeys";

const props = defineProps({
  class: { type: [String, Object, Array], default: undefined },
  float: { type: Boolean, default: false },
});

const parentContext = inject(FORM_ITEM_INJECTION_KEY, null);
const id = parentContext?.id || useId();
const name = parentContext?.name || "";

provide(FORM_ITEM_INJECTION_KEY, { id, name, float: props.float });
</script>

<template>
  <div
    data-slot="form-item"
    :class="cn(float ? 'float' : 'grid gap-2', props.class)"
  >
    <slot />
  </div>
</template>
